import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetCourseState, setStep } from "../../../../../slices/courseSlice";
import { useForm } from "react-hook-form";
import { IoIosArrowForward } from "react-icons/io";
import { COURSE_STATUS } from "../../../../../utils/constants";
import { editCourseDetails } from "../../../../../services/operations/courseDetailsAPI";

function PublishCourse(props) {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const { course } = useSelector((state) => state.course);
  const { token } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  async function handleCoursePublish(data) {
    if (
      (course?.status === COURSE_STATUS.PUBLISHED &&
        getValues("public") === true) ||
      (course?.status === COURSE_STATUS.DRAFT && getValues("public") === false)
    ) {
      // form is not updated
      goToCourses();
      return;
    }

    const formData = new FormData();
    formData.append("courseId", course._id);

    const courseStatus = getValues("public")
      ? COURSE_STATUS.PUBLISHED
      : COURSE_STATUS.DRAFT;
    formData.append("status", courseStatus);

    setLoading(true);
    const result = await editCourseDetails(formData, token);
    // console.log(result)
    if (result) {
    //   setLoading(false);
      goToCourses();
    }

    setLoading(false);
  }

  function goToCourses() {
    dispatch(resetCourseState());
    // navigate to /dashboard/mycourses
  }

  function onSubmit(data) {
    handleCoursePublish(data);
  }

  function goBack() {
    dispatch(setStep(2));
  }

  useEffect(() => {
    if (course?.status === COURSE_STATUS.PUBLISHED) {
      setValue("public", true);
    }
    //  console.log("Rerender")
  },[]);

  return (
    <div>
      <div className="rounded-md border bg-richblack-800 p-6 border-richblack-700">
        <p className="text-richblack-50 text-2xl">Publish Setting</p>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
          <div className="flex gap-x-4 items-center">
            <div className="rounded-md w-5 h-5 overflow-hidden flex justify-center items-center">
              <input
                type="checkbox"
                name="public"
                id="public"
                {...register("public")}
                className="w-10 h-14 scale-125 bg-transparent"
              />
            </div>
            <label htmlFor="public" className="text-lg text-richblack-50">
              Make this course as public
            </label>
          </div>
          <div className="flex justify-end mt-4 gap-x-2">
            <button
              onClick={goBack}
              className="bg-richblack-700 rounded-md text-richblack-100 px-4 py-2">
              Back
            </button>
            <button type="submit" className="bg-yellow-25 rounded-md flex gap-x-2 items-center text-richblack-900 px-4 py-2">
              Next <IoIosArrowForward />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PublishCourse;
